import ArrowCircleFill from './ArrowCircleFill';

export default ArrowCircleFill;
